import '../App.css'

function Disclaimer() {
  return (
    <section className="page-section">
      <div className="container">
        <div className="page-content" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
          <h1 className="page-title">Disclaimer</h1>
          
          <div className="policy-content">
            <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '1rem' }}>
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="policy-section">
              <h2>1. General Information</h2>
              <p>
                The information on this website (SkillSiksha) is provided on an "as is" basis. To the fullest extent permitted by law, we exclude all representations, warranties, and conditions relating to our website and the use of this website.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. No Warranties</h2>
              <p>
                We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through our site or any website or mobile application featured in any banner or other advertising.
              </p>
            </div>

            <div className="policy-section">
              <h2>3. Limitation of Liability</h2>
              <p>
                In no event shall SkillSiksha, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of or inability to use our website.
              </p>
            </div>

            <div className="policy-section">
              <h2>4. Job Information</h2>
              <p>
                SkillSiksha provides information about government job opportunities, exam results, admit cards, and courses. However, we are not responsible for:
              </p>
              <ul className="policy-list">
                <li>The accuracy, completeness, or timeliness of job information</li>
                <li>Any changes in job eligibility criteria, dates, or requirements</li>
                <li>Verification of official notifications from respective authorities</li>
                <li>Any consequences arising from the use of information provided on our website</li>
              </ul>
              <p style={{ marginTop: '1rem' }}>
                We strongly recommend verifying all information with official government sources before making any decisions.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. External Links</h2>
              <p>
                Our website may contain links to external websites that are not provided or maintained by or in any way affiliated with SkillSiksha. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
              </p>
            </div>

            <div className="policy-section">
              <h2>6. Third-Party Content</h2>
              <p>
                Any content, services, or information provided by third parties through our website are the responsibility of those third parties. We are not responsible for any loss or damage that may arise from your use of such third-party content, services, or information.
              </p>
            </div>

            <div className="policy-section">
              <h2>7. Educational Content</h2>
              <p>
                The courses and educational content provided on our website are for informational purposes only. We do not guarantee that following any advice or course material will result in job selection or exam success.
              </p>
            </div>

            <div className="policy-section">
              <h2>8. User Responsibility</h2>
              <p>Users are responsible for:</p>
              <ul className="policy-list">
                <li>Verifying all information with official sources before acting upon it</li>
                <li>Ensuring their eligibility before applying for any position</li>
                <li>Submitting accurate information in application forms</li>
                <li>Following all official instructions and guidelines</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>9. Updates and Changes</h2>
              <p>
                We reserve the right to modify or discontinue, temporarily or permanently, the website (or any part thereof) with or without notice. We shall not be liable to you or to any third party for any modification, suspension, or discontinuance of the website.
              </p>
            </div>

            <div className="policy-section">
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions about this Disclaimer, please contact us at:
              </p>
              <ul className="policy-list">
                <li>Email: Prabhumeena3167@gmail.com</li>
                <li>Phone: +918290114167</li>
                <li>Address: Udaipur, India</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Disclaimer

